import { Shield, Clock, CheckCircle, Award, Star, Users } from "lucide-react";

const TrustIndicators = () => {
  const indicators = [
    {
      icon: Clock,
      title: "48-Hour Approvals",
      description: "vs 60+ days at banks"
    },
    {
      icon: Shield,
      title: "Property-Based Lending",
      description: "Focus on deal value, not credit"
    },
    {
      icon: CheckCircle,
      title: "No Income Verification",
      description: "For qualified commercial deals"
    },
    {
      icon: Award,
      title: "Single Point of Contact",
      description: "One agent, start to finish"
    },
    {
      icon: Users,
      title: "200+ Clients Served",
      description: "Trusted across Canada"
    },
    {
      icon: Star,
      title: "0% Default Rate",
      description: "Strong underwriting standards"
    }
  ];

  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-primary via-primary to-primary/95 relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground mb-4">
            The Anti-Bank for Commercial Deals
          </h2>
          <p className="text-primary-foreground/80 text-lg max-w-2xl mx-auto">
            Six reasons why investors choose Atralend over traditional banks
          </p>
          <div className="w-20 h-1 bg-accent mx-auto rounded-full mt-6" />
        </div>

        {/* Indicators Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6 max-w-6xl mx-auto">
          {indicators.map((indicator, index) => (
            <div
              key={index}
              className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl p-5 text-center border border-primary-foreground/20 hover:bg-primary-foreground/15 transition-all group"
            >
              <div className="w-12 h-12 rounded-xl bg-accent/20 flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform">
                <indicator.icon className="w-6 h-6 text-accent" />
              </div>
              <h3 className="font-semibold text-primary-foreground text-sm mb-1">
                {indicator.title}
              </h3>
              <p className="text-primary-foreground/70 text-xs leading-relaxed">
                {indicator.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustIndicators;
